export interface WorldMedia {
  clip: string;
  poster: string;
}

export interface WorldSection {
  id: "clearing" | "approach" | "threshold" | "elements" | "return";
  eyebrow: string;
  title: string;
  body: string;
  accent: string;
  scroll: number;
  linger: number;
  desktop: WorldMedia;
  mobile: WorldMedia;
}

export interface WorldManifest {
  brand: string;
  sections: WorldSection[];
}

const mediaFor = (index: number, kind: "desktop" | "mobile"): WorldMedia => {
  const number = String(index + 1).padStart(2, "0");
  return {
    clip: `/world/${kind}/leg-${number}.mp4`,
    poster: `/world/posters/${kind}-${number}.webp`
  };
};

export const aeraWorldManifest: WorldManifest = {
  brand: "AERA",
  sections: [
    {
      id: "clearing",
      eyebrow: "01 · The clearing",
      title: "First, find the silence.",
      body: "Sixty acres of spruce, stone and weather. Four cabins held lightly inside it.",
      accent: "#d8ff38",
      scroll: 1.55,
      linger: 0.28,
      desktop: mediaFor(0, "desktop"),
      mobile: mediaFor(0, "mobile")
    },
    {
      id: "approach",
      eyebrow: "02 · The approach",
      title: "Let the forest reveal the architecture.",
      body: "Smoked oak, glass and warm light emerge slowly from the blue hour.",
      accent: "#d8ff38",
      scroll: 1.35,
      linger: 0.18,
      desktop: mediaFor(1, "desktop"),
      mobile: mediaFor(1, "mobile")
    },
    {
      id: "threshold",
      eyebrow: "03 · The threshold",
      title: "Leave the world on the other side.",
      body: "A quiet room aligned to rain, trees and the first light of morning.",
      accent: "#d8ff38",
      scroll: 1.5,
      linger: 0.3,
      desktop: mediaFor(2, "desktop"),
      mobile: mediaFor(2, "mobile")
    },
    {
      id: "elements",
      eyebrow: "04 · The elements",
      title: "Cedar heat. Cold air. Dark water.",
      body: "Nothing added for spectacle. Every material returns attention to the senses.",
      accent: "#d8ff38",
      scroll: 1.55,
      linger: 0.34,
      desktop: mediaFor(3, "desktop"),
      mobile: mediaFor(3, "mobile")
    },
    {
      id: "return",
      eyebrow: "05 · The return",
      title: "Go back differently.",
      body: "The same forest. A slower pulse. A little more room inside the day.",
      accent: "#d8ff38",
      scroll: 1.7,
      linger: 0.38,
      desktop: mediaFor(4, "desktop"),
      mobile: mediaFor(4, "mobile")
    }
  ]
};

export function selectWorldMedia(section: WorldSection, portrait: boolean): WorldMedia {
  return portrait ? section.mobile : section.desktop;
}
